import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';

import { SnackbarService } from "../../shared/components/snackbar/snackbar.service";
import { Admin } from "../models/admin.entity";
import { AdminRepository } from "../repositories/admin.repository";

@Injectable()
export class AdminResolver  {
  constructor(private readonly adminRepository: AdminRepository,
              private readonly snackbarService: SnackbarService,
              private readonly router: Router,
  ) {
    this.handleError = this.handleError.bind(this);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Admin | undefined> {
    const id = route.paramMap.get('id') ?? '';

    return this.adminRepository.findById(id)
      .pipe(catchError(err => this.handleError(err)));
  }

  private handleError(err: HttpErrorResponse): Observable<Admin | undefined> {
    if (err.status === 404) {
      this.snackbarService.pushMessage('L\'utilisateur recherché est introuvable', 'error');
    }
    this.router.navigate([ '/users' ]);

    return of(undefined);
  }
}
